define("shared/components/shared/post/secondary/caption-writer/credit-purchase", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless this.canAddAiCredits}}
    <div class="u--m__lr" data-test-id="credit-purchase-free-plan-details">
      <h4 class="u--m__b__xs u--m__t__0 u--text--hair">
        {{t "caption_writer.credit_purchase.free_title"}}
      </h4>
      <p class="u--text--light u--m__b__0" data-test-id="credit-purchase-details">
        {{t "caption_writer.credit_purchase.free_description"}}
      </p>
    </div>
  {{/unless}}
  {{#if this.isMobileSubscription}}
    <Shared::Ui::MobileRedirectPrompt
      @description={{t
        "plans.mobile.upgrade.feature"
        feature=(t "caption_writer.credit_purchase.feature_name")
        platform=this.subscriptionPlatform
      }}
      @title={{t "plans.mobile.upgrade_on" platform=this.subscriptionPlatform}}
      class="u--m__md"
    />
  {{else}}
    {{! Buy More Credits}}
    {{#if this.isEnterpriseSubscription}}
      <div class="tCW--card">
        <p class="u--text--base u--text--bold u--flex__alignSelf--start">
          {{t "caption_writer.credit_purchase.enterprise.more_credits_title"}}
        </p>
        <p class="u--text--sm u--text--light">
          {{html-safe
            (t "caption_writer.credit_purchase.enterprise.more_credits_description" contact_url=this.enterpriseContactUrl)
          }}
        </p>
      </div>
    {{else if this.canAddAiCredits}}
      <div class="tCW--card credit-purchase-option">
        <h3 class="u--text--base u--text--bold u--m__0">{{t "caption_writer.credit_purchase.add_more"}}</h3>
        <p class="u--text--sm u--text--light u--m__tb__xs">{{t "caption_writer.credit_purchase.unused"}}</p>
        <p class="u--text--sm u--text--light u--text--bold u--m__tb__xs">
          {{t "caption_writer.credit_purchase.extra"}}
        </p>
        <div class="tCW--cardRow">
          {{! 100 Credits}}
          <Shared::Button::Upgrade
            @feature="aiCreditsOneBundle"
            @isSimplifiedCheckout={{true}}
            @seamlessCheckoutSuccessCallback={{@onSeamlessCheckoutSuccess}}
            as |upgradeFn|
          >
            <Shared::Ui::Button
              @class="tCW--cardRow__item qa--creditsAddOn_100"
              @onClick={{upgradeFn}}
              @variant="outline"
            >
              <span class="u--text--base u--text--bold">
                {{t "caption_writer.credit_purchase.credits_amount" creditsCount=100}}
              </span>
              <span class="u--text--sm u--text--light">
                {{t "caption_writer.credit_purchase.credits_price_per_month" price="$5"}}
              </span>
            </Shared::Ui::Button>
          </Shared::Button::Upgrade>
          {{! 200 Credits}}
          <Shared::Button::Upgrade
            @feature="aiCreditsTwoBundles"
            @isSimplifiedCheckout={{true}}
            @seamlessCheckoutSuccessCallback={{@onSeamlessCheckoutSuccess}}
            as |upgradeFn|
          >
            <Shared::Ui::Button
              @class="tCW--cardRow__item qa--creditsAddOn_200"
              @onClick={{upgradeFn}}
              @variant="outline"
            >
              <span class="u--text--base u--text--bold">
                {{t "caption_writer.credit_purchase.credits_amount" creditsCount=200}}
              </span>
              <span class="u--text--sm u--text--light">
                {{t "caption_writer.credit_purchase.credits_price_per_month" price="$10"}}
              </span>
            </Shared::Ui::Button>
          </Shared::Button::Upgrade>
          {{! More Credits}}
          <Shared::Button::Upgrade
            @feature="aiCredits"
            @isSimplifiedCheckout={{true}}
            @seamlessCheckoutSuccessCallback={{@onSeamlessCheckoutSuccess}}
            as |upgradeFn|
          >
            <Shared::Ui::Button
              @class="tCW--cardRow__item qa--creditsAddOn_more"
              @onClick={{upgradeFn}}
              @variant="outline"
            >
              <span class="u--text--base u--text--bold">{{t "caption_writer.credit_purchase.more"}}</span>
            </Shared::Ui::Button>
          </Shared::Button::Upgrade>
        </div>
      </div>
    {{/if}}
    {{! Upgrade Plan}}
    {{#if this.targetPlan}}
      {{#unless this.isEnterpriseSubscription}}
        <Shared::Post::Secondary::CaptionWriter::CreditPlanDetails
          @onSeamlessCheckoutSuccess={{@onSeamlessCheckoutSuccess}}
          @rolloutAdditionalAiCredits={{@rolloutAdditionalAiCredits}}
          @subscriptionPlan={{this.targetPlan}}
        />
      {{/unless}}
      {{#unless (or this.hasNoCreditsOnPlan this.isMobileSubscription)}}
        <p class="u--text--xs u--text--light u--m__t u--m__b__0 u--p__lr" data-test-id="credit-purchase-carry-over">
          {{t "caption_writer.credit_purchase.carry_over_help"}}
        </p>
      {{/unless}}
    {{/if}}
  {{/if}}
  */
  {
    "id": "YII//W+7",
    "block": "[[[41,[51,[30,0,[\"canAddAiCredits\"]]],[[[1,\"  \"],[10,0],[14,0,\"u--m__lr\"],[14,\"data-test-id\",\"credit-purchase-free-plan-details\"],[12],[1,\"\\n    \"],[10,\"h4\"],[14,0,\"u--m__b__xs u--m__t__0 u--text--hair\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.free_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light u--m__b__0\"],[14,\"data-test-id\",\"credit-purchase-details\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.free_description\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"isMobileSubscription\"]],[[[1,\"  \"],[8,[39,3],[[24,0,\"u--m__md\"]],[[\"@description\",\"@title\"],[[28,[37,1],[\"plans.mobile.upgrade.feature\"],[[\"feature\",\"platform\"],[[28,[37,1],[\"caption_writer.credit_purchase.feature_name\"],null],[30,0,[\"subscriptionPlatform\"]]]]],[28,[37,1],[\"plans.mobile.upgrade_on\"],[[\"platform\"],[[30,0,[\"subscriptionPlatform\"]]]]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isEnterpriseSubscription\"]],[[[1,\"    \"],[10,0],[14,0,\"tCW--card\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--base u--text--bold u--flex__alignSelf--start\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.enterprise.more_credits_title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[[28,[37,1],[\"caption_writer.credit_purchase.enterprise.more_credits_description\"],[[\"contact_url\"],[[30,0,[\"enterpriseContactUrl\"]]]]]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"canAddAiCredits\"]],[[[1,\"    \"],[10,0],[14,0,\"tCW--card credit-purchase-option\"],[12],[1,\"\\n      \"],[10,\"h3\"],[14,0,\"u--text--base u--text--bold u--m__0\"],[12],[1,[28,[35,1],[\"caption_writer.credit_purchase.add_more\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__tb__xs\"],[12],[1,[28,[35,1],[\"caption_writer.credit_purchase.unused\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--sm u--text--light u--text--bold u--m__tb__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.extra\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCW--cardRow\"],[12],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@feature\",\"@isSimplifiedCheckout\",\"@seamlessCheckoutSuccessCallback\"],[\"aiCreditsOneBundle\",true,[30,1]]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,6],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"tCW--cardRow__item qa--creditsAddOn_100\",[30,2],\"outline\"]],[[\"default\"],[[[[1,\"\\n            \"],[10,1],[14,0,\"u--text--base u--text--bold\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.credits_amount\"],[[\"creditsCount\"],[100]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.credits_price_per_month\"],[[\"price\"],[\"$5\"]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[2]]]]],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@feature\",\"@isSimplifiedCheckout\",\"@seamlessCheckoutSuccessCallback\"],[\"aiCreditsTwoBundles\",true,[30,1]]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,6],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"tCW--cardRow__item qa--creditsAddOn_200\",[30,3],\"outline\"]],[[\"default\"],[[[[1,\"\\n            \"],[10,1],[14,0,\"u--text--base u--text--bold\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.credits_amount\"],[[\"creditsCount\"],[200]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.credits_price_per_month\"],[[\"price\"],[\"$10\"]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[3]]]]],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@feature\",\"@isSimplifiedCheckout\",\"@seamlessCheckoutSuccessCallback\"],[\"aiCredits\",true,[30,1]]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,6],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"tCW--cardRow__item qa--creditsAddOn_more\",[30,4],\"outline\"]],[[\"default\"],[[[[1,\"\\n            \"],[10,1],[14,0,\"u--text--base u--text--bold\"],[12],[1,[28,[35,1],[\"caption_writer.credit_purchase.more\"],null]],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[4]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]],[41,[30,0,[\"targetPlan\"]],[[[41,[51,[30,0,[\"isEnterpriseSubscription\"]]],[[[1,\"      \"],[8,[39,7],null,[[\"@onSeamlessCheckoutSuccess\",\"@rolloutAdditionalAiCredits\",\"@subscriptionPlan\"],[[30,1],[30,5],[30,0,[\"targetPlan\"]]]],null],[1,\"\\n\"]],[]],null],[41,[51,[28,[37,8],[[30,0,[\"hasNoCreditsOnPlan\"]],[30,0,[\"isMobileSubscription\"]]],null]],[[[1,\"      \"],[10,2],[14,0,\"u--text--xs u--text--light u--m__t u--m__b__0 u--p__lr\"],[14,\"data-test-id\",\"credit-purchase-carry-over\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"caption_writer.credit_purchase.carry_over_help\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null]],[]],null]],[]]]],[\"@onSeamlessCheckoutSuccess\",\"upgradeFn\",\"upgradeFn\",\"upgradeFn\",\"@rolloutAdditionalAiCredits\"],false,[\"unless\",\"t\",\"if\",\"shared/ui/mobile-redirect-prompt\",\"html-safe\",\"shared/button/upgrade\",\"shared/ui/button\",\"shared/post/secondary/caption-writer/credit-plan-details\",\"or\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/credit-purchase.hbs",
    "isStrictMode": false
  });
  let CreditPurchaseComponent = _exports.default = (_class = class CreditPurchaseComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
      _defineProperty(this, "subscriptionPlanSorting", Object.freeze(['numberOfAiCredits:asc']));
    }
    get currentPlanType() {
      return this.subscriptions.planType;
    }
    get eligiblePlanTypes() {
      const freeOptions = ['starter202506', 'growth202506', 'scale202506'];
      if (this.auth.currentAccount.hasCustomPlan) {
        return ['scale202506'];
      }
      if (this.auth.currentAccount.isOnLegacyPlan) {
        switch (this.currentPlanType) {
          case 'plus':
            return freeOptions;
          case 'starter':
          case 'premium':
          case 'brand':
            return ['growth202506', 'scale202506'];
          default:
            return freeOptions;
        }
      }
      switch (this.currentPlanType) {
        case 'starter':
        case 'starter202506':
          return ['growth202506', 'scale202506'];
        case 'growth':
        case 'growth202506':
          return ['scale202506'];
        case 'advanced':
        case 'scale202506':
        case 'scale-15':
        case 'scale-30':
          return [];
        default:
          return freeOptions;
      }
    }
    get canAddAiCredits() {
      return Boolean(this.subscriptions.subscriptionPlan?.canAddAiCredits);
    }
    get enterpriseContactUrl() {
      return this.subscriptions.enterpriseContactUrl;
    }
    get hasNoCreditsOnPlan() {
      // Note: Captures both free and legacy accounts which have no credits
      return (this.subscriptions.subscriptionPlan?.numberOfAiCredits ?? 0) === 0;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get subscriptionPlans() {
      return this.args.subscriptionPlans.filter(plan => {
        return this.eligiblePlanTypes.includes(plan.planType) && plan.isMonthly;
      });
    }
    get targetPlan() {
      if (!this.currentPlanType) {
        return;
      }
      const targetPlan = this.eligiblePlanTypes[0];
      return this.subscriptionPlans.find(plan => plan.planType === targetPlan);
    }
    get subscriptionPlatform() {
      return this.subscriptions.platform;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CreditPurchaseComponent);
});